<div *ngIf="file"
     class="file d-flex flex-row flex-nowrap align-items-center"
     (mouseenter)="onMouseEnter($event)"
     (mouseleave)="onMouseLeave($event)">
  <div class="thumb d-flex">
    <img [src]="file.content" onerror="this.src='assets/images/No_Image.png'" [width]="43" [height]="43">
  </div>
  <div class="nowrap-input file-detail d-flex flex-column ellipsis" (click)="onDownloadFile(file)">
    <div class="image-name nowrap-input">{{file.name}}</div>
    <div *ngIf="file.fileSize" class="image-size">{{file.fileSize | fileSizeFormatting}}</div>
  </div>
  <a *ngIf="showDeleteBtn" (click)="onDeleteFile(file.id)" class="icon-delete"></a>
</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/upload-file/preview-file/preview-file.component.html